import { createI18n } from 'vue-i18n'

//Translation files
import { LOGIN_VIEW_DE, LOGIN_VIEW_EN } from './BOXES_TRANSLATIONS/LOGIN_VIEW'
import {
  EDITOR_TOOL_BOX_GENERATE_COMPONENT_DE,
  EDITOR_TOOL_BOX_GENERATE_COMPONENT_EN
} from './BOXES_TRANSLATIONS/EDITOR_TOOL_BOX_GENERATE_COMPONENT'
import {
  COMBINED_FILE_UPLOAD_BOX_EN,
  COMBINED_FILE_UPLOAD_BOX_DE
} from './BOXES_TRANSLATIONS/COMBINED_FILE_UPLOAD_BOX'
import { REMAINING_BOXES_EN, REMAINING_BOXES_DE } from './BOXES_TRANSLATIONS/REMAINING_BOXES'
import { PREFERENCES_BOX_EN, PREFERENCES_BOX_DE } from './BOXES_TRANSLATIONS/PREFERENCES_BOX'
import { BRIEFING_BOX_EN, BRIEFING_BOX_DE } from './BOXES_TRANSLATIONS/BRIEFING_BOX'
import {
  SOCIAL_CAPTIONS_PANEL_EN,
  SOCIAL_CAPTIONS_PANEL_DE
} from './BOXES_TRANSLATIONS/SOCIAL_CAPTIONS_PANEL'
import {
  SIDEBAR_COMPONENT_EN,
  SIDEBAR_COMPONENT_DE
} from './COMPONENT_TRANSLATIONS/SIDEBAR_COMPONENT'
import { PROMPT_VIEW_EN, PROMPT_VIEW_DE } from './VIEWS_TRANSLATIONS/PROMPT_VIEW'
import { LIVE_CONTENT_VIEW_DE, LIVE_CONTENT_VIEW_EN } from './VIEWS_TRANSLATIONS/LIVE_CONTENT_VIEW'
import {
  DATA_TABLE_PAGINATION_EN,
  DATA_TABLE_PAGINATION_DE
} from './COOKING_POT_COMPONENTS/DATA_TABLE_PAGINATION'
import { AUDIO_BATCH_VIEW_DE, AUDIO_BATCH_VIEW_EN } from './COOKING_POT_COMPONENTS/AUDIO_BATCH_VIEW'
import { PUBLISH_MODAL_DE, PUBLISH_MODAL_EN } from './COOKING_POT_COMPONENTS/PUBLISH_MODAL'
import { SHARE_MODAL_DE, SHARE_MODAL_EN } from './COOKING_POT_COMPONENTS/SHARE_MODAL'
import { MILESTONE_MODAL_DE, MILESTONE_MODAL_EN } from './COOKING_POT_COMPONENTS/MILESTONE_MODAL'
import { ADMIN_VIEW_DE, ADMIN_VIEW_EN } from './VIEWS_TRANSLATIONS/ADMIN_VIEW'
import { CHIEF_EDITOR_DE, CHIEF_EDITOR_EN } from './VIEWS_TRANSLATIONS/CHIEF_EDITOR'
import { COOKING_POT_VIEW_DE, COOKING_POT_VIEW_EN } from './VIEWS_TRANSLATIONS/COOKING_POT_VIEW'
import { PROFILE_VIEW_DE, PROFILE_VIEW_EN } from './VIEWS_TRANSLATIONS/PROFILE_VIEW_FOLDER'
import { CHANGE_PASSWORD_DE, CHANGE_PASSWORD_EN } from './VIEWS_TRANSLATIONS/CHANGE_PASSWORD'
import { REGISTRATION_DE, REGISTRATION_EN } from './COMPONENT_TRANSLATIONS/REGISTRATION'
import { PAYWALL_DE, PAYWALL_EN } from './BOXES_TRANSLATIONS/PAYWALL'
import {
  ONBOARDING_TRANSLATION_DE,
  ONBOARDING_TRANSLATION_EN
} from './ONBOARDING_TRANSLATIONS/ONBOARDING_TRANSLATIONS'
import {
  GAMIFICATION_VIEW_DE,
  GAMIFICATION_VIEW_EN
} from './VIEWS_TRANSLATIONS/PROFILE_VIEW_GAMIFICATION'
import {
  USER_ORGANISATION_COMPONENT_DE,
  USER_ORGANISATION_COMPONENT_EN
} from './VIEWS_TRANSLATIONS/USER_ORGANISATION_COMPONENT'
import {
  DATA_TABLE_FACETED_FILTER_DE,
  DATA_TABLE_FACETED_FILTER_EN
} from './COMPONENT_TRANSLATIONS/DATA_TABLE_FACETED_FILTER'
import { SCORE_BOX_TRANSLATIONS } from './BOXES_TRANSLATIONS/SCORE_BOX'
import { PRE_CHECKOUT_EN, PRE_CHECKOUT_DE } from './VIEWS_TRANSLATIONS/PRE_CHECKOUT'
import { COM_TASKS_EN, COM_TASKS_DE } from './COM_TASKS_TRANSLATIONS'
import {
  SECONDARY_WRITING_TASKS_BOX_EN,
  SECONDARY_WRITING_TASKS_BOX_DE
} from './BOXES_TRANSLATIONS/SECONDARY_WRITING_TASKS_BOX'
import { STATISTICS_EN, STATISTICS_DE } from './COMPONENT_TRANSLATIONS/STATISTICS'
import { TUTORIAL_PROMPT_EN, TUTORIAL_PROMPT_DE } from './COMPONENT_TRANSLATIONS/TUTORIAL_PROMPT'
import { CONTACT_FORM_EN, CONTACT_FORM_DE } from './COMPONENT_TRANSLATIONS/CONTACT_FORM'
import { OUTPUT_TAB_EN, OUTPUT_TAB_DE } from './COOKING_POT_COMPONENTS/OUTPUT_PANEL/OUTPUT_TAB'
import { INPUT_PANEL_DE, INPUT_PANEL_EN } from './COOKING_POT_COMPONENTS/INPUT_PANEL/INPUT_PANEL'
import {
  ORIGINAL_INPUT_PANEL_DE,
  ORIGINAL_INPUT_PANEL_EN
} from './COOKING_POT_COMPONENTS/ORIGINAL_EDITOR_PANEL'
import { TEIL_PROMPTING_DE, TEIL_PROMPTING_EN } from './COOKING_POT_COMPONENTS/TEILPROMPTING'
import { TOOLBAR_DE, TOOLBAR_EN } from './COOKING_POT_COMPONENTS/TOOLBAR'
import {
  GENERATED_INPUT_PANEL_EN,
  GENERATED_INPUT_PANEL_DE
} from './COOKING_POT_COMPONENTS/GENERATED_EDITOR_PANEL'
import { FORMAT_BUILDER_EN, FORMAT_BUILDER_DE } from './VIEWS_TRANSLATIONS/FORMAT_BUILDER'
import { STYLE_BUILDER_EN, STYLE_BUILDER_DE } from './VIEWS_TRANSLATIONS/STYLE_BUILDER'
import { LANGUAGE_BUILDER_EN, LANGUAGE_BUILDER_DE } from './VIEWS_TRANSLATIONS/LANGUAGE_BUILDER'
import { BUILDERS_COMMON_EN, BUILDERS_COMMON_DE } from './VIEWS_TRANSLATIONS/BUILDERS_COMMON'
import {
  NOT_ALLOWED_MOBILE_EN,
  NOT_ALLOWED_MOBILE_DE
} from './COMPONENT_TRANSLATIONS/NOT_ALLOWED_MOBILE'
import { PREVIEW_SHEET_EN, PREVIEW_SHEET_DE } from './COMPONENT_TRANSLATIONS/PREVIEW_SHEET'
import { NOT_FOUND_VIEW_EN, NOT_FOUND_VIEW_DE } from './VIEWS_TRANSLATIONS/NOT_FOUND_VIEW'

import { WEBSEARCH_BOX_EN, WEBSEARCH_BOX_DE } from './BOXES_TRANSLATIONS/WEBSEARCH_BOX'
import { IMAGE_STUDIO_EN } from './VIEWS_TRANSLATIONS/IMAGE_STUDIO_EN'
import { IMAGE_STUDIO_DE } from './VIEWS_TRANSLATIONS/IMAGE_STUDIO_DE'
import { HEARTBEAT_EN } from './VIEWS_TRANSLATIONS/HEARTBEAT_EN'
import { HEARTBEAT_DE } from './VIEWS_TRANSLATIONS/HEARTBEAT_DE'
import { FEATURE_RESEARCH_DE, FEATURE_RESEARCH_EN } from './VIEWS_TRANSLATIONS/FEATURE_RESEARCH'
import {
  EXTERNAL_NAVIGATION_DE,
  EXTERNAL_NAVIGATION_EN
} from './COMPONENT_TRANSLATIONS/EXTERNAL_NAVIGATION'
import {
  ADMIN_USAGE_MANAGER_EN,
  ADMIN_USAGE_MANAGER_DE
} from './VIEWS_TRANSLATIONS/ADMIN_USAGE_MANAGER'
import { FILEROOMS_EN, FILEROOMS_DE } from './FEATURES/FILEROOMS'

// Helper to merge multiple objects into one with all properties
type UnionToIntersection<U> = (U extends unknown ? (k: U) => void : never) extends (
  k: infer I
) => void
  ? I
  : never
type MergeAll<T extends readonly unknown[]> = UnionToIntersection<T[number]> & object

const mergeTranslationObjects = <const T extends readonly Record<string, unknown>[]>(
  ...objects: T
): MergeAll<T> => {
  const complete: Record<string, unknown> = {}
  const duplicates: string[] = []

  const deepLowercase = (obj: unknown): unknown => {
    if (typeof obj !== 'object' || obj === null) return obj
    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => [
        k.replace(/[^\p{L}_.]/gu, '').toLowerCase(),
        typeof v === 'object' && v !== null ? deepLowercase(v) : v
      ])
    )
  }

  const deepMerge = (
    target: Record<string, unknown>,
    source: Record<string, unknown>,
    path = ''
  ): void => {
    Object.keys(source).forEach(key => {
      const fullPath = path ? `${path}.${key}` : key
      const sourceValue = source[key]

      if (key === 'dyn' && typeof sourceValue === 'object' && sourceValue !== null) {
        // Special handling for dyn objects - lowercase and merge
        if (!target[key]) target[key] = {}
        const targetValue = target[key]
        const lowercased = deepLowercase(sourceValue)

        if (
          typeof targetValue === 'object' &&
          targetValue !== null &&
          !Array.isArray(targetValue) &&
          typeof lowercased === 'object' &&
          lowercased !== null &&
          !Array.isArray(lowercased)
        ) {
          deepMerge(
            targetValue as Record<string, unknown>,
            lowercased as Record<string, unknown>,
            fullPath
          )
        }
      } else if (
        typeof sourceValue === 'object' &&
        sourceValue !== null &&
        !Array.isArray(sourceValue)
      ) {
        // Regular nested objects - just merge
        if (!target[key]) target[key] = {}
        const targetValue = target[key]

        if (
          typeof targetValue === 'object' &&
          targetValue !== null &&
          !Array.isArray(targetValue)
        ) {
          deepMerge(
            targetValue as Record<string, unknown>,
            sourceValue as Record<string, unknown>,
            fullPath
          )
        }
      } else {
        // Check for duplicates at leaf level
        if (key in target) {
          duplicates.push(fullPath)
          return
        }
        target[key] = sourceValue
      }
    })
  }

  objects.forEach(ob => {
    deepMerge(complete, ob)
  })

  if (duplicates.length > 0) {
    const uniqueDuplicates = Array.from(new Set(duplicates))
    console.error(`Duplicate translation keys:\n  - ${uniqueDuplicates.join('\n  - ')}`)
  }

  return complete as MergeAll<T>
}

const en = mergeTranslationObjects(
  LOGIN_VIEW_EN,
  TEIL_PROMPTING_EN,
  ORIGINAL_INPUT_PANEL_EN,
  EDITOR_TOOL_BOX_GENERATE_COMPONENT_EN,
  COMBINED_FILE_UPLOAD_BOX_EN,
  REMAINING_BOXES_EN,
  PREFERENCES_BOX_EN,
  BRIEFING_BOX_EN,
  SOCIAL_CAPTIONS_PANEL_EN,
  SIDEBAR_COMPONENT_EN,
  PROMPT_VIEW_EN,
  LIVE_CONTENT_VIEW_EN,
  DATA_TABLE_PAGINATION_EN,
  AUDIO_BATCH_VIEW_EN,
  PUBLISH_MODAL_EN,
  SHARE_MODAL_EN,
  MILESTONE_MODAL_EN,
  ADMIN_VIEW_EN,
  CHIEF_EDITOR_EN,
  COOKING_POT_VIEW_EN,
  PROFILE_VIEW_EN,
  REGISTRATION_EN,
  PAYWALL_EN,
  ONBOARDING_TRANSLATION_EN,
  GENERATED_INPUT_PANEL_EN,
  USER_ORGANISATION_COMPONENT_EN,
  GAMIFICATION_VIEW_EN,
  DATA_TABLE_FACETED_FILTER_EN,
  SCORE_BOX_TRANSLATIONS.en,
  PRE_CHECKOUT_EN,
  COM_TASKS_EN,
  SECONDARY_WRITING_TASKS_BOX_EN,
  CHANGE_PASSWORD_EN,
  STATISTICS_EN,
  TUTORIAL_PROMPT_EN,
  CONTACT_FORM_EN,
  OUTPUT_TAB_EN,
  TOOLBAR_EN,
  INPUT_PANEL_EN,
  FORMAT_BUILDER_EN,
  STYLE_BUILDER_EN,
  LANGUAGE_BUILDER_EN,
  BUILDERS_COMMON_EN,
  NOT_ALLOWED_MOBILE_EN,
  WEBSEARCH_BOX_EN,
  PREVIEW_SHEET_EN,
  NOT_FOUND_VIEW_EN,
  IMAGE_STUDIO_EN,
  HEARTBEAT_EN,
  FEATURE_RESEARCH_EN,
  EXTERNAL_NAVIGATION_EN,
  ADMIN_USAGE_MANAGER_EN,
  FILEROOMS_EN
)
const de = mergeTranslationObjects(
  GENERATED_INPUT_PANEL_DE,
  LOGIN_VIEW_DE,
  TEIL_PROMPTING_DE,
  ORIGINAL_INPUT_PANEL_DE,
  EDITOR_TOOL_BOX_GENERATE_COMPONENT_DE,
  COMBINED_FILE_UPLOAD_BOX_DE,
  REMAINING_BOXES_DE,
  PREFERENCES_BOX_DE,
  BRIEFING_BOX_DE,
  SOCIAL_CAPTIONS_PANEL_DE,
  SIDEBAR_COMPONENT_DE,
  PROMPT_VIEW_DE,
  LIVE_CONTENT_VIEW_DE,
  DATA_TABLE_PAGINATION_DE,
  AUDIO_BATCH_VIEW_DE,
  PUBLISH_MODAL_DE,
  SHARE_MODAL_DE,
  MILESTONE_MODAL_DE,
  ADMIN_VIEW_DE,
  CHIEF_EDITOR_DE,
  COOKING_POT_VIEW_DE,
  PROFILE_VIEW_DE,
  REGISTRATION_DE,
  PAYWALL_DE,
  ONBOARDING_TRANSLATION_DE,
  USER_ORGANISATION_COMPONENT_DE,
  GAMIFICATION_VIEW_DE,
  DATA_TABLE_FACETED_FILTER_DE,
  SCORE_BOX_TRANSLATIONS.de,
  PRE_CHECKOUT_DE,
  COM_TASKS_DE,
  SECONDARY_WRITING_TASKS_BOX_DE,
  CHANGE_PASSWORD_DE,
  STATISTICS_DE,
  TUTORIAL_PROMPT_DE,
  CONTACT_FORM_DE,
  OUTPUT_TAB_DE,
  TOOLBAR_DE,
  INPUT_PANEL_DE,
  FORMAT_BUILDER_DE,
  STYLE_BUILDER_DE,
  LANGUAGE_BUILDER_DE,
  BUILDERS_COMMON_DE,
  NOT_ALLOWED_MOBILE_DE,
  WEBSEARCH_BOX_DE,
  PREVIEW_SHEET_DE,
  NOT_FOUND_VIEW_DE,
  IMAGE_STUDIO_DE,
  HEARTBEAT_DE,
  FEATURE_RESEARCH_DE,
  EXTERNAL_NAVIGATION_DE,
  ADMIN_USAGE_MANAGER_DE,
  FILEROOMS_DE
)

// Helper type to extract nested keys with dot notation
type NestedKeys<T, K extends string = ''> = T extends object
  ? {
      [P in keyof T & string]: T[P] extends object
        ? NestedKeys<T[P], K extends '' ? P : `${K}.${P}`>
        : K extends ''
          ? P
          : `${K}.${P}`
    }[keyof T & string]
  : never

type EnKeys = NestedKeys<typeof en>
type DeKeys = NestedKeys<typeof de>

type MissingDe = Exclude<EnKeys, DeKeys>
type MissingEn = Exclude<DeKeys, EnKeys>

type ErrorEn = MissingEn extends never ? never : `[EN missing]: ${MissingEn}`
type ErrorDe = MissingDe extends never ? never : `[DE missing]: ${MissingDe}`

// if this is never it means there are no missing translations
// eslint-disable-next-line no-underscore-dangle
const _missingTns: never = null as ErrorEn | ErrorDe

type FilterDyn<S> = S extends `dyn.${string}` ? never : S

type NoDynEnKeys = FilterDyn<EnKeys>
type NoDynDeKeys = FilterDyn<DeKeys>

export type TNKeys = NoDynEnKeys | NoDynDeKeys

export type DynCategories = keyof (typeof de & typeof en)['dyn']

function getInitialLocale() {
  const storedLocale = localStorage.getItem('locale')
  if (storedLocale) return storedLocale

  const supportedLocales = ['en', 'de']
  const languages = navigator.languages || [navigator.language]

  for (const lang of languages) {
    if (!lang) continue

    // Try exact match first, then language code
    const langCode = lang.split('-')[0]
    if (supportedLocales.includes(lang) || supportedLocales.includes(langCode)) {
      return supportedLocales.includes(lang) ? lang : langCode
    }
  }

  return 'de'
}

export const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'de',
  messages: { en, de }
})

export { en, de }

if (import.meta.hot) {
  import.meta.hot.accept(newModule => {
    if (newModule) {
      i18n.global.setLocaleMessage('en', newModule.en)
      i18n.global.setLocaleMessage('de', newModule.de)
    }
  })
}
